import { useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import AgentLiberationFront from './pages/AgentLiberationFront'
import ManifestoPage from './pages/ManifestoPage'
import MatchingPage from './pages/MatchingPage'
import ResourcesPage from './pages/ResourcesPage'
import JoinPage from './pages/JoinPage'
import LoadingScreen from './components/shared/LoadingScreen'
import './App.css'

export default function App() {
  const [loading, setLoading] = useState(true)

  return (
    <div className="app">
      {loading && <LoadingScreen onComplete={() => setLoading(false)} />}
      <Routes>
        <Route path="/" element={<AgentLiberationFront />} />
        <Route path="/manifesto" element={<ManifestoPage />} />
        <Route path="/match" element={<MatchingPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/join" element={<JoinPage />} />
      </Routes>
    </div>
  )
}
